const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.75 3a.75.75 0 0 0-1.5 0v18c0 .414.336.75.75.75h18a.75.75 0 0 0 0-1.5H3.75z"/><path d="M6.742 18.106c.24-1.683.698-3.438 2.523-4.82C11.134 11.87 14.56 10.75 21 10.75a.75.75 0 0 0 0-1.5c-6.56 0-10.384 1.13-12.64 2.84-2.3 1.742-2.843 3.987-3.102 5.804a.75.75 0 0 0 1.484.212"/></svg>';
export {
  a as w
};
